import React from 'react';
import MainSideBar from "./MainSideBar";
import MainPanel from "./MainPanel";

export default  function  SideBar(props) {
    return (
        <React.Fragment>
            <div className="sidebar-wrapper">
                <MainSideBar logout={props.logout} />
                <MainPanel logout={props.logout} />
            </div>
        </React.Fragment>
    );
}